if(!customElements.get('scroll-snap')) {
  class ScrollSnap extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.initObserver();
        
      this.dots = [...this.querySelectorAll('[data-scroll-dot]')];
      if (!(this.dots.length > 1)) return;
        
      this.dots.forEach((dot) => {
          dot.addEventListener('click', this.handleDotClick.bind(this));
      });
    }
      
  
    handleDotClick(e) {
      const currentElement = e.target.closest('[data-scroll-dot]');
      if (!currentElement || !currentElement.dataset.dotId) return;
  
      if (currentElement.classList.contains('active-dot')) return;
  
      this.scrollToElementById(currentElement.dataset.dotId);
    }

    scrollToElementById(dotId) {
      const scrollContainer = this.querySelector('[scroll-snap-container]');
      const target = this.querySelector(`[data-snap-id="${dotId}"]`);
  
      if (!scrollContainer || !target) return;
  
      const scrollWidth = target.offsetLeft - scrollContainer.scrollLeft;
      scrollContainer.scrollBy({
        left: scrollWidth,
        behavior: 'smooth',
      });
    }
  
    initObserver() {
      this.options = {
        root: this,
        rootMargin: '0px',
        threshold: 1,
      };
  
      let observer = new IntersectionObserver(this.observeFunc.bind(this), this.options);
      this.targets = this.querySelectorAll('[data-snap-item]');
  
      this.targets.forEach((el) => {
        observer.observe(el);
      });
    }
  
    observeFunc(entries) {
      entries.forEach((entry) => {
        const targetId = entry.target.dataset.snapId;
        const snapDot = this.querySelector(`[data-dot-id="${targetId}"]`);
        if (!targetId || !snapDot) return;
  
        if (entry.isIntersecting) snapDot.classList.add('active-dot');
        else snapDot.classList.remove('active-dot');
      });
    }

  }
  
  customElements.define('scroll-snap', ScrollSnap);
}